query getGroup($slug: String) {
  gameGroup(slug: $slug) {
    id
    seoData {
      created
      updated
      seoText
      metaTitle
      metaDescription
      seoTitle
      h1
      ogTitle
      ogDescription
    }
    name
    code
    slug
    image
    showInMenu
    propsContent {
      props
    }

    subgroups {
      id
      seoData {
        created
        updated
        seoText
        metaTitle
        metaDescription
        seoTitle
        h1
        ogTitle
        ogDescription
      }
      propsContent {
        props
      }
      name
      code
      slug
      image
      showInMenu
      showPromoGame
      subgroupLikeSlider
      subgroupLikeSliderSize
    }
  }
}
